import React from 'react';
import PageHeader from './global-components/page-header';
import Cat from './section-components/cat-tech';

const CatPage = () => {
    return <div>
        <PageHeader headertitle="Tech"  />
        <Cat />
    </div>
}

export default CatPage

